(function () {
  class FireballLandSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._animTime = 500;
      this._movieScale = { x: 1.0, y: 1.0 };
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      const self = this;

      this.initialiseSymbolMovie(trackInfo.symbolId, trackInfo.getPosition());
      trackInfo.showSymbol(false);

      timerManager.addTimer(
        this._animTime,
        function (progress) {
          let scale = 1 + Math.sin(Math.PI * progress) * 0.15;
          self._movie.scale.set(
            self._movieScale.x * scale,
            self._movieScale.y * scale
          );
        },
        function () {
          self._movie.scale.set(self._movieScale.x, self._movieScale.y);
          onCellAnimFinishedCb(self);
        }
      );
    }

    initialiseSymbolMovie(symbolId, symPos) {
      this.visible = true;
      this._movie.gotoAndPlay(0);
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );

      this._potOverlays.forEach(function (overlay) {
        overlay.visible = false;
      });
      const symbolsInfo = resourceManager.getConfiguration().symbols;
      const firstCashFireballId = symbolsInfo["Symbol_Fireball20"].ID;
      if (
        symbolId >= firstCashFireballId &&
        symbolId <= symbolsInfo["Symbol_Fireball500"].ID
      ) {
        let stake = gameController.getCurrentModeStake(true);
        const possibleCashValues = [20, 40, 60, 80, 100, 200, 300, 400, 400];

        const baseVal = possibleCashValues[symbolId - firstCashFireballId];
        const value = baseVal * (stake / gameData.numLines);
        this._cashOverlay.setText(gdk.formatCurrency(value));
      } else if (
        symbolId >= symbolsInfo["Symbol_FireballMini"].ID &&
        symbolId <= symbolsInfo["Symbol_FireballMega"].ID
      ) {
        switch (symbolId) {
          case symbolsInfo["Symbol_FireballMini"].ID: {
            this._potOverlays[0].visible = true;
            break;
          }
          case symbolsInfo["Symbol_FireballMinor"].ID: {
            this._potOverlays[1].visible = true;
            break;
          }
          case symbolsInfo["Symbol_FireballMajor"].ID: {
            this._potOverlays[2].visible = true;
            break;
          }
          case symbolsInfo["Symbol_FireballMega"].ID: {
            this._potOverlays[3].visible = true;
            break;
          }
        }
      }
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
        this._movie.scale.set(this._movieScale.x, this._movieScale.y);
      }
    }
  }

  let create = function () {
    return new FireballLandSymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance._movie = resourceManager.createObject(
      "movie",
      json.playData.definition,
      instance.name,
      {
        definition: json.playData.definition,
      }
    );
    instance._movie.loop = false;
    instance._movie.gotoAndStop(0);
    instance._movie.anchor.set(0.5);
    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
    if (json.playData.scale) {
      instance._movieScale = {
        x: json.playData.scale.x,
        y: json.playData.scale.y,
      };
      instance._movie.scale.set(json.playData.scale.x, json.playData.scale.y);
    }
    if (json.playData.animTime) {
      instance._animTime = json.playData.animTime;
    }
    instance._cashOverlay = resourceManager.createObject(
      "text",
      "fireballCashOverlay",
      instance._movie,
      {
        text: "???",
        fontDefinition: "whiteGlow",
        fontSize: 34,
        maxWidth: 200,
        anchor: 0.5,
      }
    );
    instance._potOverlays = [
      resourceManager.createObject(
        "sprite",
        "fireballPotMiniOverlay",
        instance._movie,
        {
          fileName: "potBonus/Fireball_MINI.png",
          anchor: 0.5,
        }
      ),
      resourceManager.createObject(
        "sprite",
        "fireballPotMinorOverlay",
        instance._movie,
        {
          fileName: "potBonus/Fireball_MINOR.png",
          anchor: 0.5,
        }
      ),
      resourceManager.createObject(
        "sprite",
        "fireballPotMajorOverlay",
        instance._movie,
        {
          fileName: "potBonus/Fireball_MAJOR.png",
          anchor: 0.5,
        }
      ),
      resourceManager.createObject(
        "sprite",
        "fireballPotMegaOverlay",
        instance._movie,
        {
          fileName: "potBonus/Fireball_MEGA.png",
          anchor: 0.5,
        }
      ),
    ];
    instance._potOverlays.forEach(function (overlay) {
      overlay.visible = false;
    });
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "fireballLandSymbolAnimator",
    create,
    initialise,
    getRequiredFiles
  );
})();
